"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var lodash_1 = require("lodash");
var BlockNavigationMenu = (function () {
    function BlockNavigationMenu(createUi, block, di, usingFeature) {
        this.hasProjectContext = !block.$isSavedBlock;
        if (this.hasProjectContext) {
            this.projectNavigation = di.get("projectNavigation");
        }
        var navigationMenuScope = this.hasProjectContext
            ? {
                block: block,
                openProjectNavigationConfig: this.projectNavigation.configure,
                hasProjectContext: true,
                isNavEnabled: usingFeature(FeatureFlag_1.default.RefreshedNavigationMenu)
                    ? function () { return true; }
                    :
                        this.projectNavigation.isNavEnabled,
                openNavConfig: this.projectNavigation.configure,
                usingRefreshedNavigation: usingFeature(FeatureFlag_1.default.RefreshedNavigationMenu),
            }
            : {
                block: block,
                openProjectNavigationConfig: lodash_1.noop,
                hasProjectContext: false,
                isNavEnabled: function () { return true; },
                openNavConfig: lodash_1.noop,
                usingRefreshedNavigation: usingFeature(FeatureFlag_1.default.RefreshedNavigationMenu),
            };
        this.ui = createUi(require("./NavigationMenu.html"), navigationMenuScope);
    }
    return BlockNavigationMenu;
}());
exports.default = BlockNavigationMenu;
